import React from 'react';
import Select, { StylesConfig } from 'react-select'; // Import StylesConfig

// Opsi untuk dropdown, sesuai dengan yang ada di tabel
const restrictionOptions = [
    { value: 'rate', label: 'Rate' },
    { value: 'cta', label: 'CTA (Closed to Arrival)' },
    { value: 'ctd', label: 'CTD (Closed to Departure)' },
    { value: 'ss', label: 'Stop Sell' },
    { value: 'mxs', label: 'Max Stay' },
    { value: 'msa', label: 'Min Stay Arrival' },
    { value: 'mst', label: 'Min Stay Through' },
];

// ====================================================================
// PERBAIKAN: Definisikan tipe untuk opsi
// ====================================================================
type OptionType = {
    value: string;
    label: string;
};

// ====================================================================
// PERBAIKAN: Definisikan customStyles untuk z-index, sama seperti di RestrictionFilter
// ====================================================================
const customStyles: StylesConfig<OptionType, false> = { // `false` karena ini bukan multi-select
    menuPortal: (base) => ({
        ...base,
        zIndex: 9999, // Nilai z-index yang tinggi
    }),
    menu: (base) => ({
        ...base,
        zIndex: 9999, // Pastikan menu itu sendiri juga memiliki z-index
    }),
};

interface RestrictionTypeSelectorProps {
    value: OptionType | null;
    onChange: (option: OptionType | null) => void;
}

const RestrictionTypeSelector: React.FC<RestrictionTypeSelectorProps> = ({ value, onChange }) => {
    return (
        <div className="d-flex align-items-center" style={{ minWidth: '250px' }}>
            <span className="me-2 fw-medium text-muted small">Type:</span>
            <Select<OptionType> // Tambahkan tipe generik untuk type safety
                className="flex-grow-1"
                options={restrictionOptions}
                placeholder="Select Type..."
                isClearable
                isSearchable={false}
                value={value}
                onChange={onChange}
                // ====================================================================
                // PERBAIKAN: Tambahkan props untuk mengaktifkan z-index
                // ====================================================================
                styles={customStyles}
                menuPortalTarget={document.body} // Render menu di body untuk keluar dari container
                menuPosition="absolute"
            // ====================================================================
            />
        </div>
    );
};

export default RestrictionTypeSelector;